var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7666_9641)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7493 1.33261C30.8058 -1.21635 26.6823 0.13571 26.6823 3.32188V6.5212C20.3953 6.44678 16.0946 8.60788 13.2298 11.6259C10.1674 14.8522 8.9078 18.8857 8.37997 21.6437C8.11607 23.0225 9.02055 24.023 9.97112 24.3685C10.8792 24.6985 12.0926 24.5572 12.9024 23.6315C15.2008 21.0045 19.666 17.338 26.6823 17.5773V21.6782C26.6823 24.8643 30.8058 26.2163 32.7493 23.6673L38.989 15.4839C40.3372 13.7157 40.3372 11.2843 38.989 9.5161L32.7493 1.33261ZM12.4702 19.3492C15.4788 16.7235 19.7977 14.2595 26.6823 14.2595H28.368C29.2988 14.2595 30.0533 15.0017 30.0533 15.9173L30.053 21.6782L36.2925 13.4946C36.742 12.9052 36.742 12.0948 36.2925 11.5054L30.053 3.32188V8.17897C30.053 9.0945 29.2985 9.83668 28.3677 9.83668H26.6823C19.099 9.83668 15.6934 13.8886 15.6934 13.8886C14.1256 15.5403 13.1166 17.5033 12.4702 19.3492Z",
    fill: "#8968D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 1.67297H6.6665C3.90509 1.67297 1.6665 3.91154 1.6665 6.67297V33.3396C1.6665 36.1011 3.90509 38.3396 6.6665 38.3396H33.3332C36.0947 38.3396 38.3332 36.1011 38.3332 33.3396V28.3396C38.3332 27.4191 37.587 26.673 36.6665 26.673C35.746 26.673 34.9998 27.4191 34.9998 28.3396V33.3396C34.9998 34.2601 34.2537 35.0063 33.3332 35.0063H6.6665C5.74604 35.0063 4.99984 34.2601 4.99984 33.3396V6.67297C4.99984 5.75249 5.74604 5.00631 6.6665 5.00631H11.6665C12.587 5.00631 13.3332 4.26011 13.3332 3.33964C13.3332 2.41916 12.587 1.67297 11.6665 1.67297Z",
    fill: "#8968D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7666_9641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDashboard);
export default __webpack_public_path__ + "static/media/share-dashboard.a636a21306e6fca9a3f5bb60047eaf93.svg";
export { ForwardRef as ReactComponent };